// hooks
import { useEffect, useState } from "react";
// Common Components
import { WrappedTimeSeriesChart } from "src/Components/Timeseries/WrappedTimeSeriesChart";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
// Requests
import { getHourGraph, getDayGraph } from "src/Requests/goldArbitrage";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";

interface IProps {
  accountId?: number;
}

const Charts = ({ accountId }: IProps) => {
  const [hourGraphData, setHourDeltaGraphData] = useState<Graph_Dto[]>([]);
  const [dayGraphData, setDayDeltaGraphData] = useState<Graph_Dto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!accountId) return;
    fetchCharts(true);
    const interval = setInterval(() => fetchCharts(false), 20000);

    return () => clearInterval(interval);
  }, [accountId]);

  function fetchCharts(showLoading: boolean) {
    const reqs = [getHourGraph(accountId), getDayGraph(accountId)];

    if (showLoading) setLoading(true);
    Promise.all(reqs)
      .then((resp) => {
        const [hourGraph, dayGraph] = resp;
        setHourDeltaGraphData(hourGraph);
        setDayDeltaGraphData(dayGraph);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }

  return (
    <div className="flex flex-row justify-between items-stretch gap-3 w-full">
      {loading ? <FullScreenLoading /> : <></>}
      <WrappedTimeSeriesChart
        dataset={hourGraphData}
        className="w-full h-[26rem]"
        YValueType="price"
      />
      <div className="w-px self-stretch bg-slate-300" />
      <WrappedTimeSeriesChart
        dataset={dayGraphData}
        className="w-full h-[26rem]"
        withDate
        YValueType="price"
      />
    </div>
  );
};

export default Charts;
